<template>
  <div class="h-full overflow-hidden">
    <!-- 关联实体数据 -->
    <div v-for="tableDataItem of tableDataList" :key="tableDataItem.classId">
      <CardTitle :title="tableDataItem.title" cardType="default"></CardTitle>
      <el-table
        :data="tableDataItem.tableData"
        :height="`calc(30% - 40px)`"
        highlight-current-row
        element-loading-background="rgba(0, 0, 0, 0.5)"
      >
        <el-table-column
          v-for="item in getShowAttrList(tableDataItem.readTableDataColumn)"
          :key="item.code"
          show-overflow-tooltip
          :label="item.name"
          :prop="item.column"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row[item.column] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button
              @click="showReadDataDetail(row, tableDataItem.readTableDataColumn)"
              class="button-text-white"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 左侧菜单 -->
    <DeviceLedgerTabList
      @changeTab="changeTab"
      activeTab="DeviceOtherInfo"
      :collapsePanel="collapsePanel"
    ></DeviceLedgerTabList>
    <!-- 详情弹窗 -->
    <CockpitDialog
      title="详情"
      @close="readDataDetailVisible = false"
      v-if="readDataDetailVisible"
      :top="'250px'"
      :left="'555px'"
      :width="'800px'"
      :height="'500px'"
      ref="detailDialog"
    >
      <div>
        <el-row :gutter="20" class="mt-20px">
          <el-col :span="8" v-for="item of readTableDataColumn" :key="item.cloumn">
            <p class="text-hex-ffffff9f">
              {{ item.name }}：<span class="text-white leading-18px">{{
                readDataDetailData[item.column]
              }}</span>
            </p>
          </el-col>
        </el-row>
      </div>
    </CockpitDialog>
  </div>
</template>

<script>
import { EquipmentRFRelationInfoApi } from '@wiz-api/tag-management'
import SuperagentApi from '@/assets/js/superagentApi'
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import DeviceLedgerTabList from './DeviceLedgerTabList'

const deviceServer = Wiz.GetModuleServer('device-management') // 发现场使用这个baseUrl
// const deviceServer = 'http://devaspnetcore01.wiz.top:7500' // 内网测试使用这个baseUrl
const equipmentRFRelationInfoApi = new EquipmentRFRelationInfoApi()
const superagentApi = new SuperagentApi({ baseUrl: deviceServer })

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    CardTitle,
    DeviceLedgerTabList,
    CockpitDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collapsePanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    transferProps: {
      async handler() {
        this.getReleatedEntityData()
      },
      deep: true,
    },
  },
  data() {
    return {
      loading: false,
      releatedEntityData: [], // 设备台账关联实体数据
      readTableData: [],
      readTableDataColumn: [],
      relativeAttributeData: [],
      tableDataList: [],
      readDataDetailData: {},
      readDataDetailVisible: false,
    }
  },
  methods: {
    changeTab(data) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: data.code,
            origin: data.origin,
            name: data.name,
            hideTitle: data.hideTitle,
          },
          position: 'right',
          type: 'tags',
          props: this.transferProps,
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 获取设备台账关联实体数据列表
    async getReleatedEntityData() {
      const [err, res] = await equipmentRFRelationInfoApi.getList({
        sorting: '',
        skipCount: 0,
        maxResultCount: 999,
      })
      if (res && res.items) {
        this.releatedEntityData = res.items
        this.tableDataList = res.items.map((item) => {
          return {
            classId: item.classId,
            tableData: [],
          }
        })
        for (let i = 0; i < this.releatedEntityData.length; i += 1) {
          await this.getReadData(this.releatedEntityData[i])
          await this.getAttributeData(this.releatedEntityData[i].classId)
          this.filterTableCloumnData(
            this.releatedEntityData[i].showAttributeIds,
            this.releatedEntityData[i].shortName,
            this.releatedEntityData[i].classId
          )
        }
      }
    },
    // 根据关联实体数据查询table数据
    async getReadData(row) {
      this.readDialog = true
      const token = Wiz.AuthHooks.GetToken()
      const [err, res] = await superagentApi.post(
        '/api/std/StdClassData/dynamic-table-paged-result',
        {
          data: {
            classId: row.classId,
            classAttributeId: row.filterAttributeId,
            keywords: this.transferProps.code,
            maxResultCount: 15,
            skipCount: 0,
            operator: row.filterOperator,
            whereList: [],
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (res && res.code === 0 && res.data) {
        this.readTableData = res.data
        for (let i = 0; i < this.tableDataList.length; i += 1) {
          if (this.tableDataList[i].classId === row.classId) {
            this.$set(this.tableDataList[i], 'tableData', res.data)
            break
          }
        }
      }
    },
    // 获取属性数据
    async getAttributeData(entity = '', standard_id = '') {
      const token = Wiz.AuthHooks.GetToken()
      const [err, res] = await superagentApi.get('/api/std/StdClassAttribute', {
        params: {
          class_id: entity,
          // is_all: true,
          standard_id,
          pageno: 1,
          pagesize: 999,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (res && res.code === 0 && res.data) {
        this.relativeAttributeData = res.data
        return res.data
      }
      return null
    },
    // 筛选需要显示的列
    filterTableCloumnData(showAttributeIds, shortName, classId) {
      const showAttributeIdsArr = showAttributeIds.split(',')
      const readTableDataColumn = []
      for (let i = 0; i < this.relativeAttributeData.length; i += 1) {
        for (let n = 0; n < showAttributeIdsArr.length; n += 1) {
          if (this.relativeAttributeData[i].id === showAttributeIdsArr[n]) {
            readTableDataColumn.push({
              name: this.relativeAttributeData[i].attributeName,
              column: `${this.relativeAttributeData[i].classTableName}.${this.relativeAttributeData[i].columnName}`,
            })
          }
        }
      }
      for (let i = 0; i < this.tableDataList.length; i += 1) {
        if (this.tableDataList[i].classId === classId) {
          this.$set(this.tableDataList[i], 'readTableDataColumn', readTableDataColumn)
          this.$set(this.tableDataList[i], 'title', shortName)
          break
        }
      }
    },
    // 显示实体数据详情
    showReadDataDetail(row, readTableDataColumn) {
      this.readDataDetailVisible = true
      this.readDataDetailData = row
      this.readTableDataColumn = readTableDataColumn
    },
  },
  computed: {
    getShowAttrList() {
      return (readTableDataColumn) => {
        if (readTableDataColumn instanceof Array) {
          return readTableDataColumn.slice(0, 3)
        }
        return []
      }
    },
  },
  async created() {
    this.getReleatedEntityData()
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}
.button-text-white {
  span {
    color: #fff;
  }
}
</style>
